export const DATA_SET_MODES = {
  VIEW: "VIEW",
  EDIT: "EDIT",
};
